module.exports = __webpack_public_path__ + "img/marker-v2.cec8ed3.png";